import React, {Component} from 'react';
import {
    View,
    TextInput,
    BackHandler,
    Alert,
    Image,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    ImageBackground,
    NativeModules,
    FlatList,
    Text, I18nManager

} from "react-native"
import {moderateScale} from "../../tools/Scaling";
import Colors from "../../tools/Colors";
import HMIcon from "../HMIcon";
import HMTextView from "../HMTextView";
import i18n from "../../I18n/i18n";
import HMLightbox from "../lightbox/HMLightbox";
import {Tools} from "../../tools/Tools";
import Resizer from "react-image-file-resizer";
import PathFile from "../../assets/PathFile";
import HMModal from "../modal/HMModal";
import {RecordState} from "../record/audio/RecordAudio.web";
import AudioReactRecorder from "../record/audio/RecordAudio.web";
import HMModalSelectFiles from "../selectFiles/HMModalSelectFiles";

let stream = null;
let container = null;
const audioType = 'audio/*';

export default class HmFiles extends Component {
    constructor(props) {
        super(props);
        container = this;
        this.state = {
            min: null,
            max: null,
            size: null,

            Modalcategory: false,
            pickedcategory: null,

            visibleCategoryType: false,
            pickedCategoryType: null,

            visibleModal: '',

            ShowImage: props.stateParent && props.stateParent.pathImage,

            pathImage: null,
            pathImageVideo: PathFile.image.PlayVideo,
            pathVideo: null,
            index: 0,

            checked: false,
            pathCompress: null,


            currentTime: 0.0,
            playSeconds: 0.0,
            recording: false,
            paused: false,
            stoppedRecording: true,
            finished: false,
            //   audioPath: AudioUtils.DocumentDirectoryPath + '/' + new Date().getTime() + '.aac',
            //   audioPath: null,
            hasPermission: undefined,
            prepareRecord: true,


            playState: 'record', //playing, paused ,record , stop
            duration: 0,

            arrImage: props.stateParent && props.stateParent.arrImage ? props.stateParent.arrImage : [],
            alaki: false,
            audioURL: null,
            ShowAudio: false,
            recordState: false,


        }
    }

    componentWillReceiveProps(props) {


    }

    componentDidMount() {
        // BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    async _record() {

        if (!stream) {
            //stream = await navigator.mediaDevices.getUserMedia({audio: true});

            //  navigator.mediaDevices.getUserMedia({ audio: true, video: true})
            navigator.mediaDevices.getUserMedia({audio: true})
                .then(function (streamValue) {
                    stream = streamValue;
                    //  if (stream.getVideoTracks().length > 0 && stream.getAudioTracks().length > 0){
                    if (stream.getAudioTracks().length > 0) {

                        // show it to user
                        // this.audio.src = window.URL.createObjectURL(stream);
                        // this.audio.play();
                        // init recording
                        container.mediaRecorder = new MediaRecorder(stream);
                        // init data storage for video chunks
                        container.chunks = [];
                        // listen for data from media recorder
                        container.mediaRecorder.ondataavailable = e => {
                            if (e.data && e.data.size > 0) {
                                container.chunks.push(e.data);
                            }
                        };


                        //e.preventDefault();
                        // wipe old data chunks
                        container.chunks = [];
                        // start recorder with 10ms buffer
                        container.mediaRecorder.start(10);
                        // say that we're recording
                        //this.setState({recording: true,playState:"record"});
                        container.setState({recording: true, paused: false});

                        container.timerRecord();
                        //code for when none of the devices are available
                    } else {

                        container.setState(
                            {
                                playState: 'record'
                            },
                            () => {
                                if (container.timeout) {
                                    clearInterval(container.timeout);
                                }
                            }
                        )
                        // code for when both devices are available
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    container.setState(
                        {
                            playState: 'record'
                        },
                        () => {
                            if (container.timeout) {
                                clearInterval(container.timeout);
                            }
                        }
                    )

                    // code for when there is an error
                });


        }
        else {
            this.timerRecord()
        }

    }

    timerRecord() {

        container.setState({currentTime: 0},
            () => {
                this.timeout = setInterval(() => {
                    if (container.state.currentTime === 0) {

                    }
                    if (container.state.currentTime >= 60) {
                        container.switchOnPress();
                        if (container.timeout) {
                            clearInterval(container.timeout);
                        }
                    }
                    else
                        container.setState({
                            currentTime: container.state.currentTime + 1
                        })
                }, 1000);
            }
        )
    }

    _stop() {
        if (this.timeout) {
            clearInterval(this.timeout);
        }

        // e.preventDefault();
        // stop the recorder
        this.mediaRecorder.stop();
        // say that we're not recording
        //  this.setState({recording: false,playState:"stop"});
        this.setState({stoppedRecording: true, recording: false, paused: false});

        // save the video to memory
        this.saveAudio();
    }

    saveAudio() {
        // convert saved chunks to blob
        const blob = new Blob(this.chunks, {type: audioType});
        // generate video url from blob
        //  const audioURL = window.URL.createObjectURL(blob);
        // append videoURL to list of saved videos for rendering
        // const audios = this.state.audios.concat([audioURL]);
        const audios = window.URL.createObjectURL(blob);
        this.setState({audios, audioPath: audios, audioBlob: blob});
        stream.getTracks().forEach(function (track) {
            track.stop();
            stream = null;
        });

    }

    async _refreshAudio() {
        this.setState({
            ShowAudio: false,
            currentTime: 0.0,
            playSeconds: 0.0,
            recording: false,
            paused: false,
            stoppedRecording: true,
            finished: false,
            // audioPath: AudioUtils.DocumentDirectoryPath +'/' +new Date().getTime()+'.aac',
            //   audioPath: null,
            //    hasPermission: undefined,


            playState: 'record', //playing, paused ,record , stop
            duration: 0

        })

        this.props._setStateData({audioPath: null, ShowAudio: false})

    }

    switchIcon() {
//playing, paused ,record , stop
        switch (this.state.playState) {
            case 'record':

                return PathFile.image.img_record
            case 'stop':

                return PathFile.image.img_stop
            case 'playing':


                return PathFile.image.img_play

            case 'paused':

                return PathFile.image.img_pause

            default :

        }
    }

    async onShow(data) {
        if (data === 'selectaudio') {
            this.setState({
                visibleModal: data,
                Modalcategory: true,
                //    audioPath: p,
            });

        }
        else
            this.setState({
                visibleModal: data,
                Modalcategory: true,
                //    audioPath: p,
            });
    }

    switchOnPress() {
        switch (this.state.playState) {
            case 'record':


                this.setState(
                    {
                        playState: 'stop'
                    },
                    () => {
                        this.startAudio()
                        // this._record()
                    }
                )
                break;
            case 'stop':
                if (this.timeout) {
                    clearInterval(this.timeout);
                }
                this.setState(
                    {
                        playState: 'playing'
                    },
                    async () => {
                        //  await this._stop()
                        await this.stopAudio()
                    }
                )
                break;
            case 'playing':

                this.setState(
                    {
                        playState: 'paused'
                    },
                    () => {
                        this._play()
                    }
                )
                break;

            case 'paused':
                this.setState(
                    {
                        playState: 'playing'
                    },
                    () => {
                        this._pause()

                    }
                )
                break;


            default :

        }


    }

    hiddenModal() {
        this.func_switchOnPress && this.func_switchOnPress.remove()
        if (this.timeout) {
            clearInterval(this.timeout);
        }

        if (this.state.recording)
            this.setState(
                {
                    playState: 'playing'
                },
                async () => {
                    await this._stop()
                }
            )
        this.setState({
                visibleModal: ''
            },
            async () => {
                // this.state.recording?   await this._stop():null
            }
        )
    }

    render() {
        const {onPress, styleRoot, style, text, numberOfLines, type, cammas, noFont, SizeBox = 2, styleRoot2} = this.props;

        let width_item = moderateScale(300);
        //  let checkLogin = (store.getState().reducerSplashSatiaScreen.TypeLogin == 2)
        return (
            <View>
                <View style={styleRoot2 ? styleRoot2 : {}}>
                    <View
                        style={{
                            paddingHorizontal: moderateScale(16 / SizeBox),
                            // alignItems: 'center',
                            // justifyContent: 'center',

                            flexDirection: 'row',
                            alignItems: 'center',
                            //  width: '100%'
                        }}>
                        <View
                            style={{
                                //  backgroundColor: '#5b51ee',
                                backgroundColor: Colors.white,
                                height: moderateScale(160 / SizeBox),
                                width: moderateScale(160 / SizeBox),
                                //  paddingLeft:10,
                                // marginBottom:10,
                                borderStyle: 'dashed',
                                borderRadius: moderateScale(1),
                                borderWidth: moderateScale(1),
                                borderColor: Colors.colorPrimary,
                                //    borderTopColor: 'white',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginEnd: moderateScale(8 / SizeBox),
                                overflow: 'hidden',
                                padding: moderateScale(2)

                            }}>
                            <View
                                onPress={() => {
                                    // this.onShow("selectImage")
                                    this.setState({
                                        visibleModal: "selectImage",
                                        Modalcategory: true,
                                        //    audioPath: p,
                                    });
                                }}

                                style={{
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <HMIcon name={"md-images"} style={{
                                    width: moderateScale(60 / SizeBox),
                                    height: moderateScale(60 / SizeBox),
                                    textAlign: 'center',
                                    //alignSelf: 'flex-end',
                                    color: Colors.gray,
                                    //width: moderateScale(32),
                                    // height: moderateScale(32),
                                    fontSize: moderateScale(60 / SizeBox)
                                }}/>

                                <HMTextView
                                    text={i18n.t('constant.Add_photo')}
                                    style={{
                                        alignSelf: 'center',
                                        //  marginRight: moderateScale(6),
                                        // margin: moderateScale(6),
                                        textAlign: 'center',
                                        color: Colors.colorDarkText,
                                        fontSize: moderateScale(20 / SizeBox),
                                    }}/>


                            </View>
                            <label
                                onChange={this.fileSelect}

                                // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    opacity: .009
                                }}>
                                <input type="file" accept="image/*"/>

                            </label>
                        </View>
                        <FlatList
                            keyboardShouldPersistTaps="handled"
                            // ItemSeparatorComponent={
                            //     <View style={{
                            //         width: '100%',
                            //         height: moderateScale(1),
                            //         backgroundColor: '#4f4f4f'
                            //     }}/>
                            // }

                            style={{
                                //  backgroundColor: Colors.yellow,
                                //   marginBottom: moderateScale(50)
                            }}
                            horizontal={true}
                            //data={this.state.listSearch}
                            data={this.state.arrImage}
                            //data={dataList}
                            keyExtractor={(item, index) => item.id}
                            inverted={Platform.OS === 'android' && i18n.locale == 'fa'}

                            renderItem={({item, index}) => {
                                let imageUri = "data:image/png;base64," + item;
                                var blobUrl = URL.createObjectURL(item);
                                // let base64data=null;
                                // const fileReaderInstance = new FileReader();
                                // fileReaderInstance.readAsDataURL(item);
                                // fileReaderInstance.onload = () => {
                                //     base64data = fileReaderInstance.result;
                                //  }
                                return <View
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#30ee00' : '#ee0510',
                                        height: width_item / SizeBox - moderateScale(90 / SizeBox),
                                        width: width_item / SizeBox - moderateScale(20 / SizeBox),
                                        marginHorizontal: moderateScale(6 / SizeBox)
                                    }}>

                                    <View style={{
                                        position: 'relative',
                                        //backgroundColor: '#eeba0d',
                                        width: "100%",
                                        height: "100%"
                                    }}>
                                        {/*   <Image source={{uri: item}} style={{ height: 200, width: 200, flex: 1 }}/>*/}
                                        {/*<img className="pic__photo" src={"data:image/png;base64," + item} />*/}
                                        <HMLightbox uri={blobUrl}/>
                                        {/*<Image source={{uri: "https://golbama.com/uploads/thumbs/%DA%AF%D9%84-%D8%B1%D8%B2-%D9%87%D9%84%D9%86%D8%AF%DB%8C-238.png"}} style={{   width: "100%",*/}
                                        {/*height: "100%"}} />*/}


                                        {/*<Image source={{uri: imageUri, scale: 1}} style={{height: 30, width: 30}}/>*/}
                                        <TouchableOpacity
                                            onPress={() => {
                                                //  alert(index)
                                                this.state.arrImage.splice(index, 1)
                                                this.setState({
                                                    alaki: !this.state.alaki
                                                }, () => {
                                                    this.props._setStateData({arrImage: this.state.arrImage})

                                                    //     this.props.func("arrImage", this.state.arrImage)
                                                })


                                                //this.setState({ShowImage: false})
                                                //  this.setState({pathImage: null,})
                                                // this.onShow("SelectModal")
                                            }}

                                            style={{
                                                width: moderateScale(52 / SizeBox),
                                                height: moderateScale(52 / SizeBox),
                                                backgroundColor: '#ee005b',
                                                position: 'absolute',
                                                borderRadius: moderateScale(26 / SizeBox),
                                                margin: moderateScale(4 / SizeBox),
                                                top: 0,
                                                left: 0,
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>

                                            <HMIcon name={"remove"}


                                                    style={{
                                                        textAlign: 'center',
                                                        //alignSelf: 'flex-end',
                                                        color: Colors.white,
                                                        // width: moderateScale(32),
                                                        // height: moderateScale(32),
                                                        fontSize: moderateScale(44 / SizeBox)
                                                    }}/>
                                        </TouchableOpacity>
                                    </View>
                                    {/*<HMTextView*/}
                                    {/*text={index}*/}
                                    {/*type={'bold'}*/}
                                    {/*style={{*/}
                                    {/*alignSelf: 'center',*/}
                                    {/*textAlign: 'center',*/}
                                    {/*color: Colors.white,*/}
                                    {/*fontSize: moderateScale(20),*/}
                                    {/*}}/>*/}
                                </View>
                            }

                            }
                        />


                    </View>
                    <View
                        style={{
                            marginHorizontal: moderateScale(16 / SizeBox),
                            alignItems: 'center',
                            //justifyContent: 'center',

                            flexDirection: 'row',
                            // alignSelf: 'center',
                            marginVertical: moderateScale(12 / SizeBox)
                        }}>
                        <View
                            style={{
                                marginHorizontal: moderateScale(16 / SizeBox),
                                //alignItems: 'center',
                                // justifyContent: 'center',

                                flexDirection: 'row',

                            }}>

                            <View

                                style={{
                                    width: width_item / SizeBox - moderateScale(20 / SizeBox),
                                    padding: moderateScale(4),
                                    borderWidth: moderateScale(1),
                                    borderRadius: moderateScale(2),
                                    borderColor: '#ddd',
                                    borderBottomWidth: 0,
                                    shadowColor: '#000',
                                    shadowOffset: {width: 0, height: moderateScale(.8)},
                                    shadowOpacity: 0.6,
                                    shadowRadius: moderateScale(2),
                                    elevation: moderateScale(1),
                                    marginLeft: moderateScale(1),
                                    marginRight: moderateScale(1),
                                    marginTop: moderateScale(1),
                                    marginBottom: moderateScale(1),
                                    backgroundColor: Colors.white,

                                }}>

                                <View
                                    style={{
                                        position: 'relative',
                                        paddingVertical: moderateScale(20 / SizeBox),
                                        height: width_item / SizeBox - moderateScale(90 / SizeBox),
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    {
                                        // this.state.ShowImage ?
                                        this.state.ShowAudio ?
                                            <View
                                                style={{
                                                    position: 'relative',
                                                    //backgroundColor: '#eeba0d',
                                                    width: width_item / SizeBox - moderateScale(20 / SizeBox),
                                                    height: width_item / SizeBox - moderateScale(90 / SizeBox)
                                                }}>

                                                <TouchableOpacity
                                                    onPress={() => {
                                                        this.setState(
                                                            {
                                                                playState: 'paused',
                                                                visibleModal: "selectaudio",
                                                                Modalcategory: true,
                                                            },
                                                            () => {

                                                                //this._play()

                                                            }
                                                        )
                                                    }}
                                                    style={{
                                                        // width: "100%",
                                                        //height: "100%",
                                                        //resizeMode: 'contain'
                                                        //
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        backgroundColor: Colors.blackLight,
                                                    }}>
                                                    <Image
                                                        style={{
                                                            width: "30%",
                                                            height: "30%",
                                                            //resizeMode: 'contain'
                                                            //
                                                            // position: 'absolute',
                                                            // top: 0,
                                                            // left: 0,
                                                            // right: 0,
                                                            // bottom: 0,
                                                            resizeMode: 'stretch',
                                                            tintColor: Colors.white
                                                        }}
                                                        //    source={{uri: 'https://poponik.com/wp-content/uploads/2018/09/Black-Rose-00.jpg'}}
                                                        //  source={{uri: `data:image/png;base64,${this.state.pathImageVideo}`}}
                                                        source={PathFile.image.img_speaker}
                                                    />

                                                </TouchableOpacity>


                                                <TouchableOpacity
                                                    onPress={() => {

                                                        this._refreshAudio()

                                                        // this.setState({audioPath: null,})
                                                        // this.onShow("SelectModal")
                                                    }}

                                                    style={{
                                                        width: moderateScale(64 / SizeBox),
                                                        height: moderateScale(64 / SizeBox),
                                                        backgroundColor: '#ee005b',
                                                        position: 'absolute',
                                                        borderRadius: moderateScale(32 / SizeBox),
                                                        margin: moderateScale(8 / SizeBox),
                                                        top: 0,
                                                        left: 0,
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                    <HMIcon name={"remove"} style={{
                                                        textAlign: 'center',
                                                        //alignSelf: 'flex-end',
                                                        color: Colors.white,
                                                        // width: moderateScale(32),
                                                        // height: moderateScale(32),
                                                        fontSize: moderateScale(44 / SizeBox)
                                                    }}/>
                                                </TouchableOpacity>
                                            </View>
                                            :
                                            <TouchableOpacity
                                                onPress={() => {
                                                    this.onShow("selectaudio")

                                                    //this.setState({ShowImage: true})
                                                }}

                                                style={{


                                                    position: 'absolute',
                                                    paddingVertical: moderateScale(20 / SizeBox),
                                                    //backgroundColor: '#96a7ee',
                                                    //  width: moderateScale(40),
                                                    // height: moderateScale(40),
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                <HMIcon name={"ios-volume-high"} style={{
                                                    width: moderateScale(80 / SizeBox),
                                                    height: moderateScale(80 / SizeBox),
                                                    textAlign: 'center',
                                                    //alignSelf: 'flex-end',
                                                    color: Colors.gray,
                                                    //width: moderateScale(32),
                                                    // height: moderateScale(32),
                                                    fontSize: moderateScale(80 / SizeBox)
                                                }}/>

                                                <HMTextView
                                                    text={i18n.t('constant.Add_audio')}
                                                    style={{
                                                        alignSelf: 'center',
                                                        //  marginRight: moderateScale(6),
                                                        // margin: moderateScale(6),
                                                        textAlign: 'center',
                                                        color: Colors.colorDarkText,
                                                        fontSize: moderateScale(28 / SizeBox),
                                                    }}/>


                                            </TouchableOpacity>

                                    }


                                </View>

                            </View>

                        </View>

                        <View style={{width: moderateScale(8 / SizeBox)}}/>
                        <View


                            style={{
                                width: width_item / SizeBox - moderateScale(20 / SizeBox),
                                padding: moderateScale(4),
                                borderWidth: moderateScale(1),
                                borderRadius: moderateScale(2),
                                borderColor: '#ddd',
                                borderBottomWidth: 0,
                                shadowColor: '#000',
                                shadowOffset: {width: 0, height: moderateScale(.8)},
                                shadowOpacity: 0.6,
                                shadowRadius: moderateScale(2),
                                elevation: moderateScale(1),
                                marginLeft: moderateScale(1),
                                marginRight: moderateScale(1),
                                marginTop: moderateScale(1),
                                marginBottom: moderateScale(1),
                                backgroundColor: Colors.white,
                            }}>

                            <View
                                style={{
                                    position: 'relative',
                                    paddingVertical: moderateScale(20 / SizeBox),
                                    height: width_item / SizeBox - moderateScale(90 / SizeBox),
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >

                                {
                                    this.state.pathVideo ?
                                        <View
                                            style={{
                                                position: 'relative',
                                                //backgroundColor: '#eeba0d',
                                                width: width_item / SizeBox - moderateScale(20 / SizeBox),
                                                height: width_item / SizeBox - moderateScale(90 / SizeBox)
                                            }}>

                                            <HMLightbox
                                                pathVideo={this.state.pathVideo ? URL.createObjectURL(this.state.pathVideo) : null}
                                                //  pathVideo={this.state.pathVideo}
                                                source_image={this.state.pathImageVideo} type={"video"}/>


                                            <TouchableOpacity
                                                onPress={() => {
                                                    this.setState({pathVideo: false})
                                                    //   this.props.func("pathVideo", null)
                                                    this.props._setStateData({pathVideo: null})

                                                }}

                                                style={{
                                                    width: moderateScale(64 / SizeBox),
                                                    height: moderateScale(64 / SizeBox),
                                                    backgroundColor: '#ee005b',
                                                    position: 'absolute',
                                                    borderRadius: moderateScale(32 / SizeBox),
                                                    margin: moderateScale(8 / SizeBox),
                                                    top: 0,
                                                    left: 0,
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>
                                                <HMIcon name={"remove"} style={{
                                                    textAlign: 'center',
                                                    //alignSelf: 'flex-end',
                                                    color: Colors.white,
                                                    // width: moderateScale(32),
                                                    // height: moderateScale(32),
                                                    fontSize: moderateScale(44 / SizeBox)
                                                }}/>
                                            </TouchableOpacity>
                                        </View>
                                        :
                                        <TouchableOpacity

                                            onPress={() => {
                                                this.onShow("selectVideo")

                                                //this.setState({ShowImage: true})
                                            }}
                                            style={{

                                                paddingVertical: moderateScale(20 / SizeBox),
                                                //backgroundColor: '#96a7ee',
                                                //  width: moderateScale(40),
                                                //height: moderateScale(40),
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >

                                            <HMIcon name={"md-videocam"} style={{
                                                width: moderateScale(80 / SizeBox),
                                                height: moderateScale(80 / SizeBox),
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: Colors.gray,
                                                // width: moderateScale(32),
                                                // height: moderateScale(32),
                                                fontSize: moderateScale(80 / SizeBox)
                                            }}/>

                                            <HMTextView
                                                text={i18n.t('constant.Add_video')}
                                                style={{
                                                    alignSelf: 'center',
                                                    //  marginRight: moderateScale(6),
                                                    // margin: moderateScale(6),
                                                    textAlign: 'center',
                                                    color: Colors.colorDarkText,
                                                    fontSize: moderateScale(28 / SizeBox),
                                                }}/>

                                            {/*      <label
                                                onClick={() => {
                                                    this.setState({
                                                        showMessageInput: false,
                                                    })
                                                }}
                                                onChange={(event) => this.fileSelect(event, "video")}

                                                // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                                                style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    bottom: 0,
                                                    left: 0,
                                                    right: 0,
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    opacity: .009
                                                }}>
                                                <input type="file" accept="video/*"/>

                                            </label>*/}
                                        </TouchableOpacity>
                                }


                            </View>

                        </View>

                    </View>
                </View>
                <HMModalSelectFiles
                    isVisible={this.state.visibleModal}

                    arrImageFunc={(path) => {
                        //   container.state.arrImage.push(path);
                    }}
                    onShow={this.onShow}
                    hiddenModal={() => this.hiddenModal()}
                    //  setDataFunc={this.setData}
                   // setDataFunc={null}
                    _setStateData={this._setStateData}
                    _setStateDataParent={this.props._setStateData}
                    //clearState={this.clearState}
                    fileSelect={this.fileSelect}


                />
                <HMModal
                    isVisible={this.state.visibleModal === 'selectaudio'}
                    backdropColor={Colors.gray}
                    backdropOpacity={0.8}
                    animationIn="zoomInDown"
                    animationOut="zoomOutUp"
                    animationInTiming={600}
                    animationOutTiming={600}
                    backdropTransitionInTiming={600}
                    backdropTransitionOutTiming={600}
                    //style={{height: '60%'}}
                    onBackdropPress={() => this.hiddenModal()}
                    onBackButtonPress={() => this.hiddenModal()}
                >

                    <View style={{
                        height: "90%",
                        //      padding: moderateScale(6),
                        backgroundColor: Colors.white
                    }}>
                        <View
                            style={{
                                flex: 1,
                                backgroundColor: "#2b608a",
                            }}>

                            <View style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                flex: 1,
                            }}>
                                <View style={{width: moderateScale(220)}}/>
                                <View style={{
                                    flex: .4, alignItems: 'center',
                                    justifyContent: 'flex-end',
                                }}>
                                    {
                                        this.state.recording ?
                                            <Text
                                                style={{

                                                    paddingTop: moderateScale(50),
                                                    fontSize: moderateScale(50),
                                                    color: "#fff",
                                                }}>{Tools.getAudioTimeString(this.state.currentTime)}</Text>
                                            :
                                            null
                                    }

                                </View>
                                <View style={{flex: .6, alignItems: 'center'}}>
                                    <View style={{
                                        position: "absolute",
                                        top: 0,
                                        bottom: 0,
                                        left: 0,
                                        right: 0,
                                        alignItems: "center",
                                        justifyContent: "center",
                                        opacity: .009
                                    }}>
                                        <AudioReactRecorder state={this.state.recordState} onStop={this.onStopAudio}
                                                            currentTime={this.state.currentTime}/>
                                    </View>
                                    {
                                        this.state.playState == 'playing' || this.state.playState == 'paused' ?
                                            <View
                                                style={{
                                                    width: '100%',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>

                                                <audio controls style={{width: moderateScale(280)}}
                                                       src={this.state.audios}/>

                                                {/*      <Text
                                                    style={{
                                                        paddingTop: moderateScale(25),
                                                        fontSize: moderateScale(25),
                                                        color: "#fff"
                                                    }}>{Tools.getAudioTimeString(this.state.playSeconds)}</Text>*/}
                                                <View style={{
                                                    flexDirection: 'row',
                                                    marginTop: moderateScale(20),
                                                }}>
                                                    <TouchableOpacity
                                                        style={{

                                                            //    marginHorizontal: moderateScale(10),
                                                            width: moderateScale(48),
                                                            height: moderateScale(48),

                                                            justifyContent: 'center',
                                                            alignItems: 'center',

                                                            // bottom:0,
                                                        }}

                                                        onPress={
                                                            () => {
                                                                this.setState(
                                                                    {
                                                                        ShowAudio: true,
                                                                        visibleModal: '',

                                                                    }
                                                                )
                                                                // this.props.func("audioPath", this.state.audioPath)
                                                                // this.props.func("ShowAudio", true)
                                                                // this.props.func("audioBlob", this.state.audioBlob)
                                                                // this.props.func("durationVoice", this.state.currentTime)

                                                                this.props._setStateData({
                                                                    audioPath: this.state.audioPath,
                                                                    ShowAudio: true,
                                                                    audioBlob: this.state.audioBlob,
                                                                    durationVoice: this.state.currentTime,
                                                                })
                                                            }

                                                        }>
                                                        <View style={{
                                                            //  flexDirection:Rtl ? 'row-reverse': 'row',
                                                            flexDirection: 'row',
                                                            alignItems: "flex-end",
                                                            //marginHorizontal: moderateScale(4)
                                                        }}>
                                                            <HMIcon name={
                                                                'md-checkmark'
                                                            }
                                                                    style={{
                                                                        fontSize: moderateScale(40),
                                                                        color: Colors.light
                                                                    }}/>
                                                        </View>
                                                    </TouchableOpacity>
                                                    <TouchableOpacity
                                                        style={{

                                                            //    marginHorizontal: moderateScale(10),
                                                            width: moderateScale(48),
                                                            height: moderateScale(48),

                                                            justifyContent: 'center',
                                                            alignItems: 'center',

                                                            // bottom:0,
                                                        }}

                                                        onPress={
                                                            () => {
                                                                this._refreshAudio()
                                                            }

                                                        }>
                                                        <View style={{
                                                            //  flexDirection:Rtl ? 'row-reverse': 'row',
                                                            flexDirection: 'row',
                                                            alignItems: "flex-end",
                                                            //marginHorizontal: moderateScale(4)
                                                        }}>
                                                            <HMIcon name={
                                                                'ios-refresh'


                                                            }
                                                                    style={{
                                                                        fontSize: moderateScale(32),
                                                                        color: Colors.light
                                                                    }}/>

                                                        </View>
                                                    </TouchableOpacity>
                                                </View>

                                            </View>
                                            :

                                            <TouchableOpacity
                                                style={{
                                                    width: moderateScale(48),
                                                    height: moderateScale(48),
                                                    marginTop: moderateScale(15),
                                                    backgroundColor: Colors.white,
                                                    borderRadius: moderateScale(24),
                                                    alignItems: 'center',
                                                    justifyContent: 'center',

                                                }}
                                                onPress={() => {

                                                    this.func_switchOnPress = this.switchOnPress();
                                                    /*
                                                                                                        if (this.state.playState === "record")
                                                                                                            this.setState({currentTime: 0},
                                                                                                                () => {
                                                                                                                    this.timeout = setInterval(() => {
                                                                                                                        if (container.state.currentTime === 0) {

                                                                                                                        }
                                                                                                                        if (container.state.currentTime >= 60) {
                                                                                                                            container.switchOnPress();
                                                                                                                            if (container.timeout) {
                                                                                                                                clearInterval(container.timeout);
                                                                                                                            }
                                                                                                                        }
                                                                                                                        else
                                                                                                                            container.setState({
                                                                                                                                currentTime: container.state.currentTime + 1
                                                                                                                            })
                                                                                                                    }, 1000);
                                                                                                                }
                                                                                                            )
                                                                                                        else {
                                                                                                            if (this.timeout) {
                                                                                                                clearInterval(this.timeout);
                                                                                                            }
                                                                                                        }*/


                                                    // this.switchOnPress()
                                                }}
                                            >
                                                <Image
                                                    source={this.switchIcon(this.state.playState)}
                                                    style={{
                                                        width: moderateScale(24),
                                                        height: moderateScale(24),
                                                        tintColor: Colors.colorDark
                                                    }}/>
                                                {/*<Text style={{position:'absolute', alignSelf:'center', marginTop:1, color:'white', fontSize:12}}>15</Text>*/}
                                            </TouchableOpacity>
                                    }
                                </View>

                            </View>


                            <TouchableOpacity
                                style={{

                                    //    marginHorizontal: moderateScale(10),
                                    width: moderateScale(48),
                                    height: moderateScale(48),

                                    justifyContent: 'center',
                                    alignItems: 'center',

                                    position: 'absolute',
                                    top: 0,
                                    right: 0,
                                    marginTop: Platform.OS === 'ios' ? moderateScale(16) : 0
                                    // bottom:0,
                                }}

                                onPress={
                                    () => {
                                        this.setState(
                                            {
                                                // ShowAudio:f,
                                                visibleModal: '',

                                            }
                                        )
                                    }

                                }>
                                <View style={{
                                    //  flexDirection:Rtl ? 'row-reverse': 'row',
                                    flexDirection: 'row',
                                    alignItems: "flex-end",
                                    //marginHorizontal: moderateScale(4)
                                }}>
                                    <HMIcon name={
                                        //Rtl ? "ios-arrow-back":'ios-arrow-forward'
                                        I18nManager.isRTL ? "ios-arrow-back" : 'ios-arrow-forward'
                                        // 'ios-arrow-back'

                                    }
                                            style={{fontSize: moderateScale(26), color: Colors.light}}/>
                                    {/*<HMTextView text={i18n.t('constant.Back')}*/}
                                    {/*style={{paddingLeft: moderateScale(5), color: Colors.light}}/>*/}
                                </View>
                            </TouchableOpacity>

                        </View>

                    </View>
                </HMModal>
            </View>
        );
    }

    _setStateData(object) {
        container.setState(object);
    }

    startAudio = () => {

        this.setState({
            recordState: RecordState.START,
            recording: true, paused: false
        })
        container.setState({currentTime: 0},
            () => {
                this.timeout = setInterval(() => {
                    if (container.state.currentTime === 0) {

                    }
                    if (container.state.currentTime >= 60) {
                        container.switchOnPress();
                        if (container.timeout) {
                            clearInterval(container.timeout);
                        }
                    }
                    else
                        container.setState({
                            currentTime: container.state.currentTime + 1
                        })
                }, 1000);
            }
        )

    }

    stopAudio = () => {

        this.setState({
            recordState: RecordState.STOP
        })
    }

    //audioData contains blob and blobUrl
    onStopAudio = (audioData) => {
        //  console.log('audioData', audioData)

        // convert saved chunks to blob
        const blob = audioData.blob;
        // generate video url from blob
        //  const audioURL = window.URL.createObjectURL(blob);
        // append videoURL to list of saved videos for rendering
        // const audios = this.state.audios.concat([audioURL]);
        const audios = audioData.url;

        this.setState({durationVoice: this.state.currentTime,});
        this.setState({
            audios,
            audioPath: audios,
            audioBlob: blob,
            stoppedRecording: true,
            recording: false,
            paused: false,
            // visibleModal: '',
            //  currentTime: 0
        });
        // this.setState({
        //         audios, audioPath: audios, audioBlob: blob, ShowAudio: true,
        //         visibleModal: '', currentTime: 0
        //     },
        //     () => {
        //         this.setData();
        //     }
        // );
        // stream.getTracks().forEach(function (track) {
        //     track.stop();
        //     stream = null;
        // });
    }


    fileSelect = async (event, type) => {
        // NavigationService.BackTo(2)

        // this.uploadFile(image, true)


        let d = type ? "pathVideo" : "pathImage";
        //  let path = type ? event.target.files[0] : await Tools.resizeFile(event.target.files[0]);
        let path = type ? (event._pathVideo ? event._pathVideo : event.target.files[0]) : await Tools.resizeFile(event.target.files[0]);

        if (!type) {
            this.state.arrImage.push(path)
            this.props._setStateData?.({arrImage: this.state.arrImage});

        }
        else {
            this.props._setStateData({pathVideo: path})

            //  this.props.func("pathVideo", path)
        }
        this.setState({
                //ShowImage:true
                visibleModal: '',
                [d]: path,
                //ShowVideo: type,
                showMessageInput: true
            },

            () => {

            }
        )
    }
}
